/**
 * @fileoverview QuicksearchResultItem — single `bp6-menu-item` row inside
 * a QuicksearchSection. Leading icon (defaults to `search` for recent-
 * search history), ellipsis-truncated label, optional `onClick`.
 *
 * Foundry mapping: `bp6-menu-item.bp6-popover-dismiss
 * quicksearch-dialog__item__ssd8kt`.
 */

import { MenuItem, type IconName } from "@blueprintjs/core";
import type { ReactElement, ReactNode } from "react";

interface QuicksearchResultItemProps {
  label: ReactNode;
  icon?: IconName;
  onClick?: () => void;
  className?: string;
  /** Override the default data-testid (e.g. per-result `command-palette-item-<id>`). */
  dataTestId?: string;
}

export function QuicksearchResultItem({
  label,
  icon = "search",
  onClick,
  className,
  dataTestId = "quicksearch-result-item",
}: QuicksearchResultItemProps): ReactElement {
  return (
    <MenuItem data-testid={dataTestId}
      icon={icon}
      text={<span className="bp6-text-overflow-ellipsis bp6-fill">{label}</span>}
      onClick={onClick}
      className={[
        "bp-quicksearch-item",
        "bp6-popover-dismiss",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    />
  );
}
